// extracted by mini-css-extract-plugin
module.exports = {"enableModalText":"enableModalText--ZYV8-"};